<template>
    <div class="dashboard">
        <app-header :isDashboard="false"  :isProject="true" :projectTitle="projectTitle" :username="username"></app-header>

        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                <img src="../assets/img/ecdc-logo.svg" alt="ecdc-logo" class="img-fluid logo" />
                </div>
            </div>

            <div class="row align-items-center mb-40">
                <div class="col-md-3">

                </div>

                <div class="col-md-6">
                    <div class="title">Dashboard</div>
                </div>

                <div class="col-md-3">
                    <div class="amount-selected pointer d-none" v-b-modal.menu-modal>
                        All Menu
                        <font-awesome-icon :icon="['fas', 'bars']" />
                    </div>
                </div>
            </div>

            <div class="row row-cols-md-3 row-cols-2">
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'productsSummary' })">
                        <div class="icon">
                            <app-icon-product></app-icon-product>
                        </div>
                        Products & Promotions
                    </div>
                </div>

                <div v-if="!restrictDashboardUsers" class="col mb-4" @click="$router.push({ name: 'usersSummary' })">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <app-icon-users></app-icon-users>
                        </div>
                        eCDC Users
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'presetVenueSummary' })">
                        <div class="icon">
                            <app-icon-venue></app-icon-venue>
                        </div>
                        Preset Venue
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'assetsSummary' })">
                        <div class="icon">
                            <app-icon-asset-management></app-icon-asset-management>
                        </div>
                        Assets Management
                    </div>
                </div> -->

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'cdcSummary' })">
                        <div class="icon">
                            <app-icon-cdc></app-icon-cdc>
                        </div>
                        CDC (Customer Data)
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'salesSummary' });">
                        <div class="icon">
                            <app-icon-sales></app-icon-sales>
                        </div>
                        Sales
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'trialsSummary' })">
                        <div class="icon">
                           <app-icon-trial></app-icon-trial>
                        </div>
                        Trial
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'venueAnalysisSummary' })">
                        <div class="icon">
                           <app-icon-venue-analysis></app-icon-venue-analysis>
                        </div>
                        Venue Analysis
                    </div>
                </div> -->
                
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'teamArrivalSummary' })">
                        <div class="icon">
                            <app-icon-arrival></app-icon-arrival>
                        </div>
                        Team Arrival & Departure
                    </div>
                </div>
                              
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'attendancesSummary' })">
                        <div class="icon">
                            <app-icon-arrival></app-icon-arrival>
                        </div>
                        Attendance & Payroll
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'otpsSummary' })">
                        <div class="icon">
                            <app-icon-consumer-validation></app-icon-consumer-validation>
                        </div>
                        Consumer Validation
                    </div>
                </div> -->

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'announcementsDetails' })">
                        <div class="icon">
                            <app-icon-announcement></app-icon-announcement>
                        </div>
                        Announcement Management
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="menu-modal" hide-header hide-footer centered size="xl">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('menu-modal')" /> 

            <div class="row row-cols-lg-4 row-cols-2">
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'productsSummary' })">
                        <div class="icon">
                            <app-icon-product></app-icon-product>
                        </div>
                        Products & Promotions
                    </div>
                </div>

                <div v-if="!restrictDashboardUsers" class="col mb-4" @click="$router.push({ name: 'usersSummary' })">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <app-icon-users></app-icon-users>
                        </div>
                        eCDC Users
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'presetVenueDetails' })">
                        <div class="icon">
                            <app-icon-venue></app-icon-venue>
                        </div>
                        Preset Venue
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'assetsSummary' })">
                        <div class="icon">
                            <app-icon-asset-management></app-icon-asset-management>
                        </div>
                        Assets Management
                    </div>
                </div> -->

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'stockCreate' })">
                        <div class="icon">
                            <app-icon-stock></app-icon-stock>
                        </div>
                        Stock Management
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-cdc></app-icon-cdc>
                        </div>
                        CDC (Customer Data)
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-sales></app-icon-sales>
                        </div>
                        Sales
                    </div>
                </div>
                
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'trialsDetails' })">
                        <div class="icon">
                            <app-icon-trial></app-icon-trial>
                        </div>
                        Trial
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'venueAnalysisDetails' })">
                        <div class="icon">
                            <app-icon-venue-analysis></app-icon-venue-analysis>
                        </div>
                        Venue Analysis
                    </div>
                </div> -->
                
                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: 'teamArrivalDetails' })">
                        <div class="icon">
                            <app-icon-arrival></app-icon-arrival>
                        </div>
                        Team Arrival & Departure
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-attendance></app-icon-attendance>
                        </div>
                        Attendance & Payroll
                    </div>
                </div>

                <!-- <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-consumer-validation></app-icon-consumer-validation>
                        </div>
                        Consumer Validation
                    </div>
                </div> -->

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-loyalty-customers></app-icon-loyalty-customers>
                        </div>
                        Loyalty Customers
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100" @click="$router.push({ name: '' })">
                        <div class="icon">
                            <app-icon-announcement></app-icon-announcement>
                        </div>
                        Announcement Management
                    </div>
                </div>
            </div>
            
        </b-modal>
    </div>
</template>

<script>
import IconProduct from '../svg/Product.vue'
import IconUsers from '../svg/Users.vue'
import IconVenue from '../svg/Venue.vue'
import IconArrival from '../svg/Arrival.vue'
import IconStock from '../svg/Stock.vue'
// import IconVenueAnalysis from '../svg/VenueAnalysis.vue'
// import IconAssetManagement from '../svg/AssetManagement.vue'
import IconCdc from '../svg/CDC.vue'
import IconSales from '../svg/Sales.vue'
import IconTrial from '../svg/Trial.vue'
import IconAttendance from '../svg/Attendance.vue'
// import IconConsumerValidation from '../svg/ConsumerValidation.vue'
import IconLoyaltyCustomers from '../svg/LoyaltyCustomers.vue'
import IconAnnouncement from '../svg/Announcement.vue'
import Header from "./Header.vue";
import AuthMiddleware from './mixin/AuthMiddleware'
import { getProj, getAuth } from '../helpers/index'
import { checkPermission } from '../api'

export default {
    mixins: [AuthMiddleware],
    components: {
        appHeader: Header,
        appIconProduct: IconProduct,
        appIconUsers: IconUsers,
        appIconVenue: IconVenue,
        appIconArrival: IconArrival,
        appIconStock: IconStock,
        // appIconVenueAnalysis: IconVenueAnalysis,
        // appIconAssetManagement: IconAssetManagement,
        appIconCdc: IconCdc,
        appIconSales: IconSales,
        appIconTrial: IconTrial,
        appIconAttendance: IconAttendance,
        // appIconConsumerValidation: IconConsumerValidation,
        appIconLoyaltyCustomers: IconLoyaltyCustomers,
        appIconAnnouncement: IconAnnouncement,
    },
    data() {
        return {
            projectTitle: "",
            username: "",
            restrictDashboardUsers: false,
        }
    },
    async mounted() {

        this.username = getAuth().name;
        this.projectTitle = getProj().projName;
        this.restrictDashboardUsers = await this.checkPermission('restrict dashboard users');

        if(!this.projectTitle)
          this.$router.push({ name: "projectSelection" }) 
    },
    methods: {
        async checkPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        }
    }
}
</script>
